export default __webpack_public_path__ + "static/PMG_EGIB_MYRUMAH_PW_AGENCY_BM-c58b32f04d38c26e6d4be75f8feed86b.pdf";